import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

export const CarPriceBox = ({ children, sx, ...props })=>{
  return (
    <Box
      sx={{
        flexBasis:'100%',
        borderRadius:'15px',
        border:'1px solid',
        borderColor:'primary.main',
        p:2,
        textAlign:'center',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
export default CarPriceBox;
CarPriceBox.propTypes ={
  children:PropTypes.node,
  sx: PropTypes.shape({}),
};
CarPriceBox.defaultProps={
  sx:{}
};